var map = {
	"./labour-1 .png": "Ci2h",
	"./labour-1.png": "/ftp",
	"./labour-10.png": "SbMp",
	"./labour-11.png": "WOyA",
	"./labour-2.png": "MyNw",
	"./labour-3.png": "aMtm",
	"./labour-4.png": "3qEQ",
	"./labour-5.png": "Lklu",
	"./labour-6.png": "i0cE",
	"./labour-7.png": "2/l5",
	"./labour-8.png": "r7v2",
	"./labour-9.png": "iS2Z"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Ga4L";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list ^\.\/labour\-.*\.png$
// module id = Ga4L
// module chunks = 1